import {
  LOADING_DATA,
  SET_GENERATED_URL,
  SET_PINTEREST_BOARDS,
  SET_SELECTED_BOARDS,
  SET_DRAGGED_MEDIA,
  SET_AFFILIATE_DATA,
  SET_WISE_TAG,
  CLEAR_ERRORS,
  STOP_LOADING_DATA,
  CLEAR_DATA,
  SET_ALL_POST_URLS,
  SET_USED_SITE_MAP,
  SET_SHOP_LISTINGS,
  UPDATE_LISTING,
  SET_IS_BULK_SCHEDULING,
  ADD_BOARD,
  SET_BOARD_SECTIONS,
  SET_PRICING_PARITY,
  SET_NEW_TREND_ALERT_SETTINGS,
  UPDATE_NEW_TREND_ALERT_SETTINGS,
  SET_USER_TREND_ALERTS,
  SET_RSS_FEEDS,
  SET_ACTIVE_CATALOG,
  SET_ALL_CATALOGS,
  DELETE_CATALOG,
  ADD_CATALOG,
  UPDATE_CATALOG,
  SET_CATALOG_ITEMS,
  DELETE_CATALOG_ITEM_IMAGE,
  ADD_CATALOG_ITEM_IMAGE,
  UPDATE_CATALOG_ITEM,
  DELETE_CATALOG_ITEM,
} from "../types";

const initialState = {
  loading: false,
  pinterestBoards: [],
  selectedBoards: [],
  selectedBoardSections: {},
  draggedMedia: {},
  affiliateData: {},
  allPostURLs: [],
  usedSitemap: "",
  shopListings: { count: 0, listings: [] },
  isBulkScheduling: false,
  pricingParity: {
    percentageAdjustment: 1,
    countryCode: "US",
  },
};

export default function (state = initialState, action) {
  // Check if post is in origin posts
  let index;
  switch (action.type) {
    case LOADING_DATA:
      return {
        ...state,
        loading: true,
      };
    case STOP_LOADING_DATA:
      return {
        ...state,
        loading: false,
      };
    case CLEAR_DATA:
      return initialState;
    case CLEAR_ERRORS: {
      return {
        ...state,
        loading: false,
      };
    }
    case SET_GENERATED_URL: {
      return {
        ...state,
        generatedURL: action.payload,
      };
    }
    case SET_PINTEREST_BOARDS:
      return {
        ...state,
        pinterestBoards: action.payload,
      };
    case SET_SELECTED_BOARDS:
      return {
        ...state,
        selectedBoards: action.payload,
      };
    case ADD_BOARD:
      return {
        ...state,
        pinterestBoards: [action.payload, ...state.pinterestBoards],
      };
    case SET_DRAGGED_MEDIA:
      return {
        ...state,
        draggedMedia: action.payload,
      };
    case SET_AFFILIATE_DATA:
      return {
        ...state,
        loading: false,
        affiliateData: action.payload,
      };
    case SET_WISE_TAG:
      return {
        ...state,
        affiliateData: {
          ...state.affiliateData,
          affiliateProfile: {
            ...state.affiliateData.affiliateProfile,
            wiseTag: action.payload,
          },
        },
      };
    case SET_ALL_POST_URLS:
      return {
        ...state,
        allPostURLs: action.payload,
      };
    case SET_USED_SITE_MAP:
      return {
        ...state,
        usedSitemap: action.payload,
      };
    case SET_SHOP_LISTINGS: {
      if (!action.payload || !action.payload.listings) {
        return {
          ...state,
          shopListings: { count: 0, listings: [] },
        };
      }

      function decodeHtmlEntities(html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        return doc.documentElement.textContent;
      }

      const decodedListings = action.payload.listings.map((listing) => ({
        ...listing,
        title: decodeHtmlEntities(listing.title),
        description: decodeHtmlEntities(listing.description),
      }));

      return {
        ...state,
        shopListings: { ...action.payload, listings: decodedListings },
      };
    }
    case UPDATE_LISTING: {
      const updatedListings = state.shopListings.listings.map((listing) =>
        action.payload.listing.id == listing.id
          ? action.payload.listing
          : listing
      );

      return {
        ...state,
        shopListings: {
          ...state.shopListings,
          listings: updatedListings,
        },
      };
    }
    case SET_IS_BULK_SCHEDULING:
      return {
        ...state,
        isBulkScheduling: action.payload,
      };
    case SET_BOARD_SECTIONS: {
      const enrichedSections = action.payload.sections.map((section) => ({
        ...section,
        type: "section",
        sectionId: section.id,
        boardId: action.payload.boardId,
        id: section.id + "-" + action.payload.boardId,
      }));

      const existingSectionIds = new Set(
        state.pinterestBoards
          .filter((b) => b.type === "section")
          .map((b) => `${b.boardId}-${b.sectionId}`)
      );

      const newSections = enrichedSections.filter(
        (section) =>
          !existingSectionIds.has(`${section.boardId}-${section.sectionId}`)
      );

      const newPinterestBoards = [];
      state.pinterestBoards.forEach((board) => {
        if (board.id == action.payload.boardId) {
          newPinterestBoards.push({ ...board, isSectionsLoaded: true });
          newPinterestBoards.push(...newSections);
        } else {
          newPinterestBoards.push(board);
        }
      });

      return {
        ...state,
        pinterestBoards: newPinterestBoards,
      };
    }
    case SET_PRICING_PARITY:
      return {
        ...state,
        pricingParity: action.payload,
      };
    default:
      return state;
  }
}
